<template>
    <div class="c-cc-default">


        <b-link v-if="displayAdd" @click="onAddNewClick" href="#" class="card-header-action btn-setting">
            {{Core.Definition.getDefinition('Enregistrer une nouvelle carte')}}
        </b-link>
        <b-link v-if="displaySelectSaved" @click="onSelectSavedClick" href="#" class="card-header-action btn-setting">
            {{Core.Definition.getDefinition('Sélectionner ...')}}
        </b-link>
        <hr/>

        <Request
                ref="requestDefault"
                method="GET"
                :root="defaultRoot"
                :onRequestSuccess="onRequestSuccess">
            <slot slot="body">
                <table width="100%">
                    <tr v-if="dataValue.type !== undefined">
                        <td>
                            {{dataValue.type}}
                        </td>
                        <td>
                            {{dataValue.number}}
                        </td>
                        <td>
                            {{dataValue.expiration}}
                        </td>
                    </tr>
                    <tr v-else>
                        <td>{{Core.Definition.getDefinition('Aucune carte de crédit enregistrée')}}</td>
                    </tr>
                </table>
            </slot>
        </Request>

        <ModalSaveCC
                ref="modalSaveCC"
                @onTokenizationSuccess="onTokenizationSuccess">
        </ModalSaveCC>

        <ModalInstanceSelector
                ref="modalInstanceSelector"
                :caption="Core.Definition.getDefinition('Cartes enregistrées')"
                :root="savedRoot"
                v-model="dataSavedCC"
                size="m"
                :multiple="false"
                :searchArgs="[
                            {
                                key: 'entityId',
                                value: entityId
                            },
                            {
                                key: 'entityType',
                                value: entityType
                            }
                        ]"
                :options="{
                                pagination: true,
                                header: true,
                                responsive: false,
                                striped: true,
                                headerStyle: '1',
                                emptyText: Core.Definition.getDefinition('Aucune carte enregistrée'),
                                borderVariant: 'white',
                                noBody: true
                    }"
                :columns="[
                                {
                                    label: Core.Definition.getDefinition('Type'),
                                    key: 'type',
                                },
                                {
                                    label: Core.Definition.getDefinition('Numéro'),
                                    key: 'number',
                                },
                                {
                                    label: Core.Definition.getDefinition('Expiration'),
                                    key: 'expiration',
                                }]"></ModalInstanceSelector>
    </div>
</template>
<script>
    import ModalSaveCC from './ModalSaveCC'
    import Request from './Request'
    import ModalInstanceSelector from './ModalInstanceSelector'
    export default {
        name: 'CCDefault',
        components: {
            ModalSaveCC,
            Request,
            ModalInstanceSelector
        },
        props: {
            value: {
                type: Object,
                default: function() {
                    return {
                        id: ''
                    }
                }
            },
            defaultRoot: {
                type: String,
                default: '/cc'
            },
            savedRoot: {
                type: String,
                default: '/cc/list'
            },
            entityId: {
                type: Number | String,
                default: ''
            },
            entityType: {
                type: String,
                default: 'user',
                required: true
            },
            displayAdd: {
                type: Boolean,
                default: true
            },
            displaySelectSaved: {
                type: Boolean,
                default: true
            }
        },
        watch: {
            value(val) {
                this.dataValue = val
            },
            dataValue(val) {
                this.$emit('input', val)
            },
            dataSavedCC(val) {
                if (val[0].instance !== undefined) {
                    this.setDefault(val[0].instance)
                }
            }
        },
        mounted() {
            this.retrieve()
            this.dataValue = this.value
        },
        data: function () {
            return {
                Core: window.Core,
                dataSavedCC: [],
                dataValue: {}
            }
        },
        methods: {
            onAddNewClick() {
                this.$refs.modalSaveCC.open = true
            },
            onSelectSavedClick() {
                this.$refs.modalInstanceSelector.open = true
            },
            onRequestSuccess(data) {
                if (data.default !== undefined) {
                    this.dataValue = data.default
                }
            },
            retrieve() {
                this.$refs.requestDefault.setMethod('GET')
                this.$refs.requestDefault.clearArgs()
                if (Core.Validation.isId(this.entityId)) {
                    this.$refs.requestDefault.addArg('entityId', this.entityId)
                }
                this.$refs.requestDefault.addArg('entityType', this.entityType)
                this.$refs.requestDefault.request()
            },
            setDefault(instance) {
                this.$refs.requestDefault.setMethod('PUT')
                this.$refs.requestDefault.clearArgs()
                this.$refs.requestDefault.addArg('id', instance.id)
                this.$refs.requestDefault.addArg('entityType', this.entityType)
                this.$refs.requestDefault.request()
            },
            createDefault(CC) {
                this.$refs.modalSaveCC.open = false
                this.$refs.requestDefault.setMethod('POST')
                this.$refs.requestDefault.clearArgs()
                this.$refs.requestDefault.addArg('entityId', this.entityId)
                this.$refs.requestDefault.addArg('token', CC.token)
                this.$refs.requestDefault.addArg('entityType', this.entityType)
                this.$refs.requestDefault.request()
            },
            onTokenizationSuccess(CC) {
                this.createDefault(CC)
            }
        }
    }
</script>

